import { render, staticRenderFns } from "./exhibition-concact.vue?vue&type=template&id=4b43221e&scoped=true&"
import script from "./exhibition-concact.vue?vue&type=script&lang=js&"
export * from "./exhibition-concact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b43221e",
  null
  
)

export default component.exports